var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuickMenuButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 46,
    viewBox: "0 0 182 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.748 34.9895C164.393 34.6913 167.298 32.5784 169.488 29.7663C170.444 28.5376 171.261 27.1804 171.93 25.7769C172.346 24.9029 172.758 23.9158 173.015 22.9699C172.758 22.0188 172.346 21.0369 171.93 20.1629C171.261 18.7594 170.444 17.4022 169.488 16.1735C167.298 13.3614 164.393 11.2485 160.748 10.9503L159.818 10.8732V9.93751C159.818 6.12805 156.728 3.03832 152.918 3.03832H28.6661C24.8566 3.03832 21.7669 6.12805 21.7669 9.93751V10.8732L20.8364 10.9503C17.1914 11.2485 14.2868 13.3614 12.0967 16.1735C11.1405 17.4022 10.3231 18.7594 9.65476 20.1629C9.23834 21.0369 8.8322 22.024 8.57001 22.9699C8.82706 23.921 9.23834 24.9029 9.65476 25.7769C10.3231 27.1804 11.1405 28.5376 12.0967 29.7663C14.2868 32.5784 17.1914 34.6913 20.8364 34.9895L21.7669 35.0666V36.0023C21.7669 39.8117 24.8566 42.9015 28.6661 42.9015H152.913C156.723 42.9015 159.813 39.8117 159.813 36.0023V35.0666L160.743 34.9895H160.748Z",
    fill: "url(#paint0_linear_101_1250)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.833 45.9398H23.7513C11.7214 45.9398 2.91494 33.4318 0 22.9699C2.91494 12.5029 11.7214 0 23.7513 0H157.838C169.868 0 178.675 12.508 181.59 22.9699C178.675 33.4369 169.868 45.9398 157.838 45.9398H157.833ZM160.748 34.9895C164.393 34.6913 167.298 32.5784 169.488 29.7663C170.444 28.5376 171.261 27.1804 171.93 25.7769C172.346 24.9029 172.758 23.9158 173.015 22.9699C172.758 22.0188 172.346 21.0369 171.93 20.1629C171.261 18.7594 170.444 17.4022 169.488 16.1735C167.298 13.3614 164.393 11.2485 160.748 10.9503L159.818 10.8732V9.93752C159.818 6.12805 156.728 3.03832 152.918 3.03832H28.6661C24.8566 3.03832 21.7669 6.12805 21.7669 9.93752V10.8732L20.8364 10.9503C17.1914 11.2485 14.2868 13.3614 12.0967 16.1735C11.1405 17.4022 10.3231 18.7594 9.65476 20.1629C9.23834 21.0369 8.8322 22.024 8.57001 22.9699C8.82706 23.921 9.23834 24.9029 9.65476 25.7769C10.3231 27.1804 11.1405 28.5376 12.0967 29.7663C14.2868 32.5784 17.1914 34.6913 20.8364 34.9895L21.7669 35.0666V36.0023C21.7669 39.8118 24.8566 42.9015 28.6661 42.9015H152.913C156.723 42.9015 159.813 39.8118 159.813 36.0023V35.0666L160.743 34.9895H160.748Z",
    fill: "url(#paint1_linear_101_1250)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.1078 22.9699C4.91478 13.5259 12.9296 2.02555 23.7513 2.02555H157.838C168.655 2.02555 176.67 13.5259 179.477 22.9699H181.585C178.67 12.508 169.863 0 157.833 0H23.7513C11.7214 0 2.91494 12.5029 0 22.9699H2.1078Z",
    fill: "url(#paint2_radial_101_1250)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.1078 22.9688C4.91478 32.4127 12.9296 43.9131 23.7462 43.9131H157.833C168.65 43.9131 176.665 32.4127 179.472 22.9688H181.579C178.665 33.4306 169.858 45.9387 157.828 45.9387H23.7513C11.7266 45.9387 2.91494 33.4358 0 22.9688H2.1078Z",
    fill: "url(#paint3_linear_101_1250)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52088 22.969C8.28174 19.8793 12.4151 10.6204 20.7538 9.94176C20.7538 5.57192 24.2959 2.02979 28.6657 2.02979H23.7458C12.9292 2.02465 4.9144 13.525 2.10742 22.969H7.52088Z",
    fill: "url(#paint4_radial_101_1250)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52088 22.9688C8.28174 26.0585 12.4151 35.3174 20.7538 36.0011C20.7538 40.371 24.2959 43.9131 28.6657 43.9131H23.7458C12.9292 43.9131 4.9144 32.4127 2.10742 22.9688H7.52088Z",
    fill: "url(#paint5_linear_101_1250)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.60096 22.9688C5.41307 13.5248 13.4227 2.02441 24.2445 2.02441H23.751C12.9292 2.02441 4.9144 13.5248 2.10742 22.9688H2.60096Z",
    fill: "url(#paint6_linear_101_1250)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.60096 22.9688C5.40793 32.4127 13.4227 43.9131 24.2393 43.9131H23.7458C12.9292 43.9131 4.9144 32.4127 2.10742 22.9688H2.60096Z",
    fill: "url(#paint7_radial_101_1250)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.058 22.969C173.297 19.8793 169.163 10.6204 160.83 9.94176C160.83 5.57192 157.288 2.02979 152.918 2.02979H157.838C168.655 2.02979 176.669 13.5302 179.476 22.9741H174.063L174.058 22.969Z",
    fill: "url(#paint8_radial_101_1250)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.058 22.9688C173.297 26.0585 169.163 35.3174 160.83 36.0011C160.83 40.371 157.288 43.9131 152.918 43.9131H157.838C168.655 43.9131 176.669 32.4127 179.476 22.9688H174.063H174.058Z",
    fill: "url(#paint9_linear_101_1250)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.978 22.9688C176.171 13.5248 168.156 2.02441 157.34 2.02441H157.833C168.65 2.02441 176.665 13.5248 179.472 22.9688H178.978Z",
    fill: "url(#paint10_linear_101_1250)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.978 22.9688C176.171 32.4127 168.156 43.9131 157.34 43.9131H157.833C168.65 43.9131 176.665 32.4127 179.472 22.9688H178.978Z",
    fill: "url(#paint11_radial_101_1250)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.717 35.8847C169.056 35.2061 173.189 25.942 173.945 22.8523C173.184 19.7626 169.051 10.5037 160.717 9.82506C160.717 5.45522 157.175 1.91309 152.805 1.91309H28.5531C24.1832 1.91309 20.6411 5.45522 20.6411 9.82506C12.3024 10.5037 8.16907 19.7677 7.4082 22.8523C8.16907 25.942 12.3024 35.2009 20.6411 35.8847C20.6411 40.2545 24.1832 43.7967 28.5531 43.7967H152.8C157.17 43.7967 160.712 40.2545 160.712 35.8847H160.717ZM172.902 22.8523C172.644 21.9012 172.233 20.9193 171.817 20.0453C171.148 18.6418 170.331 17.2846 169.375 16.0559C167.185 13.2438 164.28 11.1309 160.635 10.8327L159.705 10.7556V9.81991C159.705 6.01045 156.615 2.92072 152.805 2.92072H28.5531C24.7436 2.92072 21.6539 6.01045 21.6539 9.81991V10.7556L20.7233 10.8327C17.0784 11.1309 14.1737 13.2438 11.9837 16.0559C11.0275 17.2846 10.21 18.6418 9.54171 20.0453C9.12529 20.9193 8.71915 21.9064 8.45696 22.8523C8.71401 23.8034 9.12529 24.7853 9.54171 25.6593C10.21 27.0628 11.0275 28.42 11.9837 29.6487C14.1737 32.4608 17.0784 34.5737 20.7233 34.8719L21.6539 34.949V35.8847C21.6539 39.6942 24.7436 42.7839 28.5531 42.7839H152.8C156.61 42.7839 159.699 39.6942 159.699 35.8847V34.949L160.63 34.8719C164.275 34.5737 167.18 32.4608 169.37 29.6487C170.326 28.42 171.143 27.0628 171.812 25.6593C172.228 24.7853 172.639 23.7982 172.896 22.8523H172.902Z",
    fill: "url(#paint12_linear_101_1250)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.57024 22.9679C8.82729 22.0169 9.23857 21.0349 9.65499 20.161C10.3233 18.7575 11.1407 17.4003 12.097 16.1716C14.287 13.3594 17.1917 11.2465 20.8366 10.9483L21.7671 10.8712L20.7544 9.93555C12.4157 10.6142 8.28235 19.8782 7.52148 22.9628H8.57024V22.9679Z",
    fill: "url(#paint13_linear_101_1250)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.65499 25.7757C9.23857 24.9018 8.83243 23.9147 8.57024 22.9688H7.52148C8.28235 26.0585 12.4157 35.3174 20.7544 36.0011L21.7671 35.0655L20.8366 34.9884C17.1917 34.6902 14.287 32.5772 12.097 29.7651C11.1407 28.5364 10.3233 27.1792 9.65499 25.7757Z",
    fill: "url(#paint14_linear_101_1250)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.24 22.9679C172.983 22.0169 172.572 21.0349 172.155 20.161C171.487 18.7575 170.669 17.4003 169.713 16.1716C167.523 13.3594 164.618 11.2465 160.973 10.9483L160.043 10.8712L161.056 9.93555C169.394 10.6142 173.528 19.8782 174.283 22.9628H173.235L173.24 22.9679Z",
    fill: "url(#paint15_linear_101_1250)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.929 25.7757C172.346 24.9018 172.757 23.9147 173.014 22.9688H174.063C173.302 26.0585 169.169 35.3174 160.835 36.0011L159.822 35.0655L160.753 34.9884C164.398 34.6902 167.302 32.5772 169.492 29.7651C170.449 28.5364 171.266 27.1792 171.934 25.7757H171.929Z",
    fill: "url(#paint16_linear_101_1250)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6241 10.0814C21.6241 6.27194 24.7138 3.18221 28.5233 3.18221H152.771C156.58 3.18221 159.67 6.27194 159.67 10.0814V11.0171L160.682 10.0814C160.682 5.71157 157.14 2.16943 152.771 2.16943H28.5233C24.1535 2.16943 20.6113 5.71157 20.6113 10.0814L21.6241 11.0171V10.0814Z",
    fill: "url(#paint17_linear_101_1250)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6659 42.9013C24.8564 42.9013 21.7667 39.8115 21.7667 36.0021V35.0664L20.7539 36.0021C20.7539 40.3719 24.296 43.914 28.6659 43.914H152.913C157.283 43.914 160.825 40.3719 160.825 36.0021L159.812 35.0664V36.0021C159.812 39.8115 156.723 42.9013 152.913 42.9013H28.6659Z",
    fill: "url(#paint18_linear_101_1250)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.7898 1.31055C114.613 1.31055 136.267 1.58302 152.358 2.02514H29.2266C45.3178 1.58302 66.9716 1.31055 90.7949 1.31055H90.7898Z",
    fill: "url(#paint19_linear_101_1250)"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.7907 43.2363C112.105 43.2363 131.482 43.478 145.876 43.8738H35.7051C50.0998 43.478 69.4762 43.2363 90.7907 43.2363Z",
    fill: "#C1E5F5"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6533 8.92411C15.8696 9.48447 13.7669 10.5744 11.6797 13.1089C12.8158 9.91631 15.3555 8.24036 18.4144 7.77767C19.0107 5.69043 20.152 4.56455 22.1827 3.90137C20.7535 5.14034 20.0852 6.26622 19.6533 8.92411Z",
    fill: "url(#paint20_linear_101_1250)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.93 8.92411C165.714 9.48447 167.816 10.5744 169.903 13.1089C168.767 9.91631 166.228 8.24036 163.169 7.77767C162.572 5.69043 161.431 4.56455 159.4 3.90137C160.83 5.14034 161.498 6.26622 161.93 8.92411Z",
    fill: "url(#paint21_linear_101_1250)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6533 37.0143C15.8696 36.454 13.7669 35.3641 11.6797 32.8296C12.8158 36.0221 15.3555 37.6981 18.4144 38.1608C19.0107 40.248 20.152 41.3739 22.1827 42.0371C20.7535 40.7981 20.0852 39.6722 19.6533 37.0143Z",
    fill: "url(#paint22_linear_101_1250)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.93 37.0143C165.714 36.454 167.816 35.3641 169.903 32.8296C168.767 36.0221 166.228 37.6981 163.169 38.1608C162.572 40.248 161.431 41.3739 159.4 42.0371C160.83 40.7981 161.498 39.6722 161.93 37.0143Z",
    fill: "url(#paint23_linear_101_1250)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_1250",
    x1: 90.7897,
    y1: 45.9398,
    x2: 90.7897,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#352C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0C10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_101_1250",
    x1: 90.7897,
    y1: 45.9398,
    x2: 90.7897,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C4D96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EA1CD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_101_1250",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.7897 11.4849) scale(64.7095 64.7095)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7987AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_101_1250",
    x1: 90.7897,
    y1: 45.9387,
    x2: 90.7897,
    y2: 22.9688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#493F82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#887BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE1EE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_101_1250",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.3866 12.4968) scale(11.9579 11.9579)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3C2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#788FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#536376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#36404C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#1E242B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#0E1014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#040505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_101_1250",
    x1: 2.10742,
    y1: 33.4409,
    x2: 28.6657,
    y2: 33.4409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_101_1250",
    x1: 13.176,
    y1: 22.9688,
    x2: 13.176,
    y2: 2.02441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_101_1250",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.176 33.4409) scale(10.7755)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7987AD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_101_1250",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(166.192 0.256147) scale(11.9579 11.9579)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3C2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#788FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#536376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#36404C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#1E242B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#0E1014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#040505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_101_1250",
    x1: 166.192,
    y1: 22.9688,
    x2: 166.192,
    y2: 43.9131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_101_1250",
    x1: 168.408,
    y1: -0.00113241,
    x2: 168.408,
    y2: -0.00113241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_101_1250",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(168.408 33.4409) scale(10.7755 10.7755)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7987AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_101_1250",
    x1: 7.4082,
    y1: 22.8574,
    x2: 173.945,
    y2: 22.8574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_101_1250",
    x1: 14.6469,
    y1: 22.9679,
    x2: 14.6469,
    y2: 9.94069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7671B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_101_1250",
    x1: 14.6469,
    y1: 36.0011,
    x2: 14.6469,
    y2: 22.9688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99ABD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_101_1250",
    x1: 167.163,
    y1: 9.94069,
    x2: 167.163,
    y2: 22.9679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7671B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_101_1250",
    x1: 166.937,
    y1: -0.00114732,
    x2: 166.937,
    y2: -0.00114732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99ABD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_101_1250",
    x1: 90.652,
    y1: 11.0171,
    x2: 90.652,
    y2: 2.16943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_101_1250",
    x1: 90.7895,
    y1: 43.914,
    x2: 90.7895,
    y2: 35.0664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CCE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFDBF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_101_1250",
    x1: 90.7898,
    y1: 2.02514,
    x2: 90.7898,
    y2: 1.31055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDEF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C66A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_101_1250",
    x1: 11.6797,
    y1: 8.50769,
    x2: 22.1827,
    y2: 8.50769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_101_1250",
    x1: 159.4,
    y1: 8.50769,
    x2: 169.903,
    y2: 8.50769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_101_1250",
    x1: 11.6797,
    y1: 37.4308,
    x2: 22.1827,
    y2: 37.4308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_101_1250",
    x1: 159.4,
    y1: 37.4308,
    x2: 169.903,
    y2: 37.4308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickMenuButton);
export default __webpack_public_path__ + "static/media/quick-menu-button.c319e70834559b101a9e8a71c8cacdab.svg";
export { ForwardRef as ReactComponent };